import React from 'react';
import { NewsList } from '../../components/NewsList/NewsList';

export const NewsPage: React.FC = () => {
    return (
        <NewsList />
    );
};